export const IsValidEmail = email => {
  if (email === undefined) {
    return false
  }
  if (email?.length <= 2) {
    return false
  }

  if (email?.indexOf('@') === -1 || email?.indexOf('@') === 0) {
    return false
  }

  var parts = email?.split('@')
  var dot = parts?.[1]?.indexOf('.')
  var dotSplits = parts?.[1]?.split('.')
  var dotCount = dotSplits?.length - 1

  if (dot === -1 || dot < 2 || dotCount > 2) {
    return false
  }

  for (var i = 0; i < dotSplits?.length; i++) {
    if (dotSplits?.[i]?.length === 0) {
      return false
    }
  }

  let part = email?.split('@')
  let dots = part?.[1]?.indexOf('.')
  let dotSplit = part?.[1]?.split('.')
  let dotCounts = dotSplit?.length - 1

  if (dots === -1 || dots < 2 || dotCounts > 2) {
    return false
  }

  for (let i = 0; i < dotSplit?.length; i++) {
    if (dotSplit?.[i]?.length === 0) {
      return false
    }
  }

  return true
}
